import React, { useRef } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import Draggable from 'react-draggable';

function BaasicDraggableModalTemplate({ modalParams, children, ...other }) {
    const nodeRef = useRef(null);
    return (
        <Modal
            overlayClassName='modal__overlay'
            className='modal__content'
            isOpen={modalParams.isOpen}
            {...other}
        >
            <Draggable handle=".modal__header" nodeRef={nodeRef}>
                <div ref={nodeRef} className='modal-content'>
                    <span
                        className='u-icon u-icon--sml u-icon--close--dark modal__icon--close'
                        onClick={modalParams.close}
                    />
                    {React.cloneElement(children, { modalParams })}
                </div>
            </Draggable>
        </Modal>
    );
}

BaasicDraggableModalTemplate.propTypes = {
    modalParams: PropTypes.object,
    children: PropTypes.any,
    hideNavigation: PropTypes.bool
};

export default defaultTemplate(BaasicDraggableModalTemplate);
